/* global Conf.get("ws_enabled"), Conf.get("ws_ttl"), tab, Conf.get("preloader_enabled"), isSearch, jsDate, clock, baseUrl, version, test_platform */

window.CONSTANTS = { // глобальные статичные данные, с бэка и не только
	ORG: { // данные связанные с оргом
		FORMS: { // коды организационных форм
			FIZ: "100731702",
			IP: "100679729",
			UR: "100731703",
		}
	}
}; 
window.STATE = {}; // глобальные динамические данные

function loadJs(url) {
	var script = document.createElement('script');
	script.src = url;
	document.head.append(script);
}

var isMacOS = /mac/i.test(navigator.platform);
const isIOS = /(iPad|iPhone|iPod|MacIntel)/.test(navigator.userAgent) && !window.MSStream;

//переменная для подсчета карт в торгах
var maxMaps = 0; // уточнить для чего
function sgToggleOpen(e) {
	e.preventDefault();
	var $target = $(e.target);
	var parent = $target.parents(".search-group-select");
	var drop = $(".sgs-drop", parent);
	var shadow = $(".sgs-drop-shadow", parent);
	var button = $(parent).children("button");
	if ($(".icon-caret", button).hasClass("open")) {
		$(drop, parent).hide();
		$(shadow, parent).hide();
	} else {
		$(drop, parent).show().focus();
		$(shadow, parent).css({"display": "flex", "height": $(document).height() + "px"});
	}
	$(".icon-caret", button).toggleClass("open");
}

jQuery(document).ready(function () {
	if ((isIOS || isMobile) && !isMainPage()) {
		$('.header__menu_back').removeClass('header__menu_back--hidden');
	}
	
	if (isSearch) {
		if (document.querySelector('.search__image') !== null) {
			document.querySelector('.search__image').onclick = function (e) {
				this.classList.toggle('close');
				document.querySelector('#adaptive_search #searchtext-adapt').classList.toggle('active');
				document.querySelector('#adaptive_search .sline').classList.toggle('active');
				document.querySelector('#adaptive_search #logo').classList.toggle('active');
				if ($('#adaptive_search .sline').hasClass('active')) {
					$('#searchtext-adapt').focus();
				}
			};
		}
	}

	SimpleBar.instances.get(document.querySelector('[data-simplebar]'));
	jQuery('[data-scrollbar]').scrollbar({
		"autoScrollSize": true,
		onInit: function (obj) {
			var $trs = jQuery("[data-status='1'],[data-status='2']", obj);
			if ($trs.length > 0) {
				//Прокрутка графика снижения цены
				setTimeout(function () {
					obj.get(0).scrollTop = $trs.get(0).offsetTop - obj.get(0).clientHeight / 2;
				}, 0);
			}
		}
	});

	jQuery(".datepicker").inputDate();
	jQuery("[data-input-inn]").inputInn();
	jQuery("[data-input-phone]").inputPhone();
	
	useTrimOnBlur($('input[name="login"]'));  // убираем пробелы и табуляцию для поля ввода логина

	$("select[data-fastselect-filtered]").multipleSelect({
		locale: 'ru',
		minimumCountSelected: 1,
		hideSelectedGroup: true,
		placeholder: '',
		selectAll: false,
		filter: true,
		groupCollapsed: false,
	});
	$("select[data-fastselect]").multipleSelect({
		locale: 'ru',
		minimumCountSelected: 1,
		hideSelectedGroup: true,
		placeholder: '',
		selectAll: false,
//		dropWidth: '100%',
		filter: false,
		groupCollapsed: false,
		shouldOpenGroup: true, // открывать список при клике на чекбокс группы
		scrollOnOpenedGroup: true, // Добавляем скролл до группы если она открылась
		maxHeight: false, // не ограничиваем высоту
		hideScroll: true, // убираем скролл
	});
	$("select[data-searchselect]").multipleSelect({
		locale: 'ru',
		minimumCountSelected: 1,
		hideSelectedGroup: true,
		placeholder: '',
		selectAll: false,
		dropWidth: '100%',
		filter: true,
	});

	$(".sgs-choice").on("click", sgToggleOpen);
	$(".sgs-drop-close-btn").on("click", function (event) {
		var parent = $(event.target).parents('.search-group-select');
		$(".sgs-drop:visible, .sgs-drop-shadow:visible", parent).hide();
		$(".icon-caret.open", parent).removeClass("open");
	});
	$(document).on("click", function (e) {
		e.stopPropagation();
		if ($(e.target).parents(".ui-datepicker")?.length === 0 && !$(e.target).hasClass("ui-datepicker")) {
			//клики по datepicker не учитываем
			if($(e.target).hasClass("ui-icon-circle-triangle-w") || $(e.target).hasClass("ui-icon-circle-triangle-e") || $(e.target).hasClass("ui-datepicker-prev") || $(e.target).hasClass("ui-datepicker-next")){
				//Костыль для кнопок календаря
				return;
			}
			
			$('.search-group-select').each(function (idx, item) {
				if ($(e.target).parents('.search-group-select')[0] === item) {
					return;
				}
				$(".sgs-drop:visible", item).hide();
				$(".icon-caret.open", item).removeClass("open");
			});
		}

		jQuery(".popup-opener.active").each(function (idx, item) {
			if ((jQuery(e.target).hasClass("popup-opener") && jQuery(e.target)[0] === item) || jQuery(e.target).parents(".popup-opener")[0] === item) {
				return;
			}
			if (jQuery(e.target).hasClass("popup-block") || jQuery(e.target).parents(".popup-block").length > 0) {
				return;
			}
			jQuery(item).removeClass("active");
		});
	});
	$(".radio-checkbox-container input[type='checkbox']").on("change", function (event) {
		var target = event.target;
		var container = $(target).parents(".radio-checkbox-container");
		var $input_val = $("input[type='hidden']", container);
		var is_checked = $(target).prop("checked");
		if (is_checked) {
			$("input[type='checkbox']", container).prop({"checked": false});
			$(target).prop({"checked": true});
		}
		var val = $("input[type='checkbox']:checked", container).val();
		$input_val.val(val);
	});
	$(".tooltip").tooltip();

	clock.setClock(jsDate, "clockTime", "clockDate");
	if (typeof window['jQuery'] === "function" && typeof jQuery['tablesorter'] !== "undefined") {
		jQuery(".tablesorter").tablesorter();
	}
	if (typeof window['jQuery'] === "function" && typeof jQuery['ui']['combobox'] === "function") {
		jQuery(".combobox").combobox();
	}
	var val = localStorage.getItem('displayby');
	if (val) {
		if ($('input[name=displayby]').length > 1) {
			//новый дизайн
			localStorage.removeItem('displayby');
		} else {
			$('input[name=displayby]').val(val);
		}

	}
	$("[data-gen-uuid]").val(uuidv4());
	if (typeof (Conf.get("ws_enabled")) !== "undefined" && Conf.get("ws_enabled") === true) {
		tab = new CommunicatorWS('ws', {ttlWS: Conf.get("ws_ttl")});
	}
	$("input[inputmask]").each(function (n, el) {
		$(el).inputmask({mask: [$(el).attr("inputmask")]});
	});

	jQuery(".search-table-container input[name='text']").on("change keyup", function (event) {
		var $target = jQuery(event.target);
		var container = $target.parents(".search-table-container");
		var table = jQuery("table", container);
		var value = $target.val();
		if (value.length > 0) {
			jQuery("tbody tr:not(.ignore-search)", table).hide();
			var els = jQuery("tbody tr:not(.ignore-search)", table).filter(function (idx, el) {
				return jQuery(el).text().toLowerCase().indexOf(value.toLowerCase()) > -1;
			});
			jQuery(els).show();
			jQuery("tbody tr.no-search", table).hide();
		} else {
			jQuery("tbody tr:not(.ignore-search)", table).show();
		}
	});
	if (test_platform) {
		showTestPlatform();
	}
	$(window).on('resize', onResize);
	if (document.scrollingElement.scrollTop === 0 && jQuery("input[type=text]:visible:not(.support-fc-input)").length === 1) {
		if (jQuery("input[type=text]:visible:not(.support-fc-input)").attr("name") === "lots") {
			jQuery("input[type=text]:visible:not(.support-fc-input)").focus();
		}
	}

});

function onResize() {
	if (test_platform) {
		showTestPlatform();
	}
	if (typeof window["initSpecialOffers"] === "function") {
		setTimeout(function () {
			window["initSpecialOffers"]();
		}, 0);
	}
	if (typeof window["initKvaSpis"] === "function") {
		setTimeout(function () {
			window["initKvaSpis"]();
		}, 0);
	}
}

function showTestPlatform() {
	var testDiv = jQuery(".test-div");
	if (testDiv.length === 0) {
		testDiv = jQuery("<div>").addClass("test-div");
		jQuery(".h-logo").append(testDiv);
	}
	jQuery(testDiv).html("DEMO " + document.documentElement.clientWidth + "x" + document.documentElement.clientHeight);

}

if (Conf.get("preloader_enabled") && !isMacOS) {
	//preloader
	$(window).on('beforeunload', function (e) {
		if (e && e.target && e.target.activeElement) {
			var a = e.target.activeElement;
			if ($(a).hasClass('no-preloader')) {
				return;
			}
			if ($(a).attr("href") && ($(a).attr("href").endsWith("doc") || $(a).attr("href").endsWith("docx") || $(a).attr("href").endsWith("pdf") || $(a).attr("href").endsWith("csv"))) {
				return;
			}
		}
		$("#preloader").removeClass('activ_preloader');
		if (typeof e === "undefined") {
			$("#preloader").addClass('activ_preloader');
		}
		if (e) {
			window.onblur = function () {
				console.log('interactive');
				$("#preloader").addClass('activ_preloader');
			};
			$("#preloader").removeClass('activ_preloader');
		}
	});
	//при подгрузке страниц из истории 
	window.addEventListener("pagehide", function (event) {
		$("#preloader").addClass('activ_preloader');
	}, false);
}

function resetZoom() {
	var meta = document.querySelector('meta[name="viewport"]');
	if (meta !== null) {
		var initMetaContent = meta.content;
		meta.content = 'width=device-width';
		meta.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0';
		meta.content = initMetaContent;
	}
}

/**
 * Добавляет форматирование по regex выражению указанному в атрибуте data-allowed-chars
 * Используется немного где, может его как-нибудь потом слить с другими методами форматирования...
 * @param select - строка с селектом или объект jquery
 * @returns {undefined}
 */
function checkInputFieldRegExp(select) {
	let elems = null;
	
	if(select) { // если что-то передано, то по нему ищем + проверяем не добавлена ли уже проверка
		if(typeof select === 'string') {
			elems = $(select + ':not([data-active-regex])');
		} else if (select.jquery)  {
			elems = select.not('[data-active-regex]');
		}
	} else { // если ничего не передано, то по стандарту проверяем
		elems = $('input[type=text][data-allowed-chars]:not([data-active-regex])'); // проверяем везде при загрузке страницы
	}
	
	if(elems === null || elems.length === 0) { // проверка на всякий случай
		return;
	}
	
	elems.each(function () {
		$(this).attr('data-active-regex', 'true'); // добавляем флаг, защищающий от повторного добавления проверки
		
		$(this).on('keypress', function () {
			var event = window.event;
			var target = event.target;
			var text = null;
			var code = event.charCode;
			if (code === null || code === "undefined")
				code = event.keyCode;
			if (code < 32 || event.charCode === 0 || event.ctrlKey || event.altKey)
				return false;
			var symbol = String.fromCharCode(code);
			var allowed = new RegExp($(target).attr("data-allowed-chars"));
			if (symbol.match(allowed) === null) { // Недопустимый символ?
				if (event.preventDefault)
					event.preventDefault();
				if (event.returnValue)
					event.returnValue = false;
				return false;
			}
			return true;
		});

		$(this).on('paste', function (event) {
			var target = event.target;
			var paste = this;
			setTimeout(function () {
				var pasteVal = $(paste).val();
				var allowed = new RegExp($(target).attr("data-allowed-chars"));
				for (var i = 0; i < pasteVal.length; i++) {
					if (pasteVal[i].match(allowed) === null) {
						pasteVal = pasteVal.slice(0, i) + " " + pasteVal.slice(i + 1);
						$(paste).val(pasteVal);
					}
				}
			}, 100);
		});
	});
}

async function playVideo(el) {
	$(el).removeClass("thumb");

	if ($(el).hasClass("video-youtube")) {
		$("iframe", el).remove();
		if (void 0 === window["YT"]) {
			await loadScript("https://www.youtube.com/iframe_api");
		}
		YT.ready(function () {
			yplayer = new YT.Player($(el).attr('id'), {
				origin: 'https://m-ets.ru/',
				videoId: $(el).attr('data-id'),
				playerVars: {
					'autoplay': 1,
					'controls': 1,
					'rel': 0
				},
			});
			yplayer.elementId = $(el).attr('id');
		});
		return;
	}
	$("iframe", el).attr("src", $("iframe", el).attr("data-src"));
	var player = $("iframe", el)[0];
	player.onload = function () {
		if ($(el).hasClass("video-rutube")) {
			setTimeout(function () {
				console.log('starting');
				player.contentWindow.postMessage(JSON.stringify({
					type: 'player:play'
				}), '*');
			}, 1000);
		}
	}
}